import { render } from "./SelectSpace.vue?vue&type=template&id=2e96e66a&ts=true"
import script from "./SelectSpace.vue?vue&type=script&lang=ts"
export * from "./SelectSpace.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__